import StoreLocationsScreen from '../screens/store-locations'

export default StoreLocationsScreen
